module.exports = __webpack_public_path__ + "static/media/pencil-dark.97b09549.svg";